import React from 'react';
import '../styles/LegalPages.css';

const DatenschutzPage = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Datenschutzerklärung</h1>
        <p className="last-updated">Stand: August 2026</p>

        <p>
          Diese Datenschutzerklärung informiert Sie über die Bearbeitung Ihrer Personendaten auf der
          Plattform WennWieWo (wennwiewo.ch) gemäss dem Schweizer Datenschutzgesetz (DSG) sowie der
          Europäischen Datenschutz-Grundverordnung (DSGVO), soweit diese anwendbar ist.
        </p>

        <h2>1. Verantwortlicher</h2>
        <div className="contact-box">
          <p style={{ marginBottom: 4 }}><strong>WennWieWo</strong></p>
          <p style={{ marginBottom: 0 }}>E-Mail: kontakt@wennwiewo.ch</p>
        </div>
        <p>
          Bei Fragen zum Datenschutz können Sie uns jederzeit per E-Mail kontaktieren.
        </p>

        <h2>2. Welche Daten wir erheben</h2>

        <h3>2.1 Besucherinnen und Besucher (ohne Konto)</h3>
        <p>
          Beim Besuch unserer Webseite werden keine personenbezogenen Daten automatisch gespeichert.
          Wir setzen keine Tracking-Tools, keine Analyse-Dienste und keine Werbe-Cookies ein.
        </p>

        <h3>2.2 Registrierte Nutzerinnen und Nutzer</h3>
        <p>Bei der Registrierung erheben wir folgende Daten:</p>
        <ul>
          <li>E-Mail-Adresse</li>
          <li>Passwort (verschlüsselt gespeichert, nie im Klartext)</li>
          <li>Profilname</li>
          <li>Datum der Kontoerstellung</li>
        </ul>

        <h3>2.3 Veranstalterinnen und Veranstalter (verifiziertes Profil)</h3>
        <p>Freiwillig können zusätzlich folgende Daten angegeben werden:</p>
        <ul>
          <li>Veranstaltername / Firmenname</li>
          <li>Beschreibung</li>
          <li>Webseite</li>
          <li>Instagram-Profil-URL</li>
          <li>TikTok-Profil-URL</li>
        </ul>

        <h3>2.4 Events</h3>
        <p>Bei der Erfassung eines Events werden folgende Daten gespeichert:</p>
        <ul>
          <li>Titel, Beschreibung, Event-Typ</li>
          <li>Datum, Uhrzeit, Ort, Kanton</li>
          <li>Mindestalter, Preis, Webseite (optional)</li>
          <li>Bannerbild (optional, hochgeladene Datei)</li>
          <li>Verknüpfung mit dem Veranstalter-Konto</li>
        </ul>

        <h2>3. Zweck und Rechtsgrundlagen der Datenbearbeitung</h2>
        <ul>
          <li>
            <strong>Bereitstellung des Dienstes:</strong> Zur Verwaltung von Konten, zur Anzeige
            von Events und zur Kommunikation mit Nutzenden (Rechtsgrundlage: Vertragserfüllung,
            Art. 6 Abs. 1 lit. b DSGVO / Art. 31 DSG).
          </li>
          <li>
            <strong>Sicherheit:</strong> Passwörter werden mit bcrypt gehasht.
            Authentifizierung erfolgt über sichere Tokens.
          </li>
          <li>
            <strong>Moderation:</strong> Events und Veranstalter-Verifizierungen werden durch
            Administratoren geprüft, um die Qualität der Plattform zu gewährleisten
            (berechtigtes Interesse, Art. 6 Abs. 1 lit. f DSGVO / Art. 31 DSG).
          </li>
          <li>
            <strong>Freiwillige Profilangaben:</strong> Optionale Profilinformationen werden nur
            auf Ihren ausdrücklichen Wunsch hin gespeichert und öffentlich angezeigt
            (Einwilligung, Art. 6 Abs. 1 lit. a DSGVO / Art. 31 DSG).
          </li>
        </ul>

        <h2>4. Speicherdauer</h2>
        <p>
          Ihre Daten werden gespeichert, solange Ihr Konto aktiv ist. Nach der Löschung Ihres
          Kontos werden alle personenbezogenen Daten sowie alle damit verknüpften Events
          unwiderruflich gelöscht.
        </p>
        <p>
          Hochgeladene Bannerbilder werden beim Ersetzen oder bei der Konto-Löschung von unseren
          Servern entfernt.
        </p>

        <h2>5. Weitergabe von Daten</h2>
        <p>
          Wir geben Ihre personenbezogenen Daten <strong>nicht</strong> an Dritte weiter, verkaufen
          sie nicht und nutzen sie nicht für Werbezwecke. Eine Weitergabe erfolgt nur:
        </p>
        <ul>
          <li>wenn wir gesetzlich dazu verpflichtet sind (z. B. auf behördliche Anordnung), oder</li>
          <li>zur Erbringung des Dienstes durch Hosting-Anbieter (Auftragsverarbeiter), die
            vertraglich zur Einhaltung des Datenschutzes verpflichtet sind.</li>
        </ul>

        <h2>6. Hosting und Server</h2>
        <p>
          Unsere Webseite und Datenbank werden auf Servern in der Schweiz gehostet.
          Die Datenverarbeitung erfolgt ausschliesslich für den Betrieb dieser Plattform.
        </p>

        <h2>7. Cookies und Tracking</h2>
        <p>
          Wir verwenden <strong>keine Tracking-Cookies</strong> und keine Analyse- oder
          Werbedienste von Drittanbietern. Die Authentifizierung erfolgt über ein Token, das lokal
          in Ihrem Browser gespeichert wird (localStorage). Dieses Token enthält keine
          personenbezogenen Daten ausser einem verschlüsselten Verweis auf Ihr Konto.
        </p>

        <h2>8. Ihre Rechte</h2>
        <p>
          Gemäss DSG und DSGVO haben Sie folgende Rechte bezüglich Ihrer personenbezogenen Daten:
        </p>
        <ul>
          <li>
            <strong>Auskunft (Art. 25 DSG / Art. 15 DSGVO):</strong> Sie können jederzeit
            Auskunft darüber verlangen, welche Daten wir über Sie gespeichert haben.
          </li>
          <li>
            <strong>Berichtigung (Art. 32 DSG / Art. 16 DSGVO):</strong> Sie können unrichtige
            Daten jederzeit in Ihrem Profil korrigieren oder eine Korrektur bei uns beantragen.
          </li>
          <li>
            <strong>Löschung (Art. 32 DSG / Art. 17 DSGVO):</strong> Sie können Ihr Konto
            jederzeit selbst in den Kontoeinstellungen löschen. Alle Ihre Daten und Events werden
            dabei unwiderruflich entfernt.
          </li>
          <li>
            <strong>Einschränkung der Bearbeitung (Art. 18 DSGVO):</strong> Sie können unter
            bestimmten Voraussetzungen die Einschränkung der Verarbeitung Ihrer Daten verlangen.
          </li>
          <li>
            <strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, Ihre
            Daten in einem gängigen Format zu erhalten. Kontaktieren Sie uns hierfür per E-Mail.
          </li>
          <li>
            <strong>Widerspruch (Art. 21 DSGVO):</strong> Sie können der Verarbeitung Ihrer Daten
            auf Basis berechtigter Interessen jederzeit widersprechen.
          </li>
          <li>
            <strong>Widerruf der Einwilligung:</strong> Einwilligungen können Sie jederzeit mit
            Wirkung für die Zukunft widerrufen (z. B. durch Löschen freiwilliger Profilangaben
            oder des Kontos).
          </li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte wenden Sie sich an: <strong>kontakt@wennwiewo.ch</strong>
        </p>

        <h2>9. Beschwerderecht bei der Aufsichtsbehörde</h2>
        <p>
          Sie haben das Recht, sich bei der zuständigen Datenschutzbehörde zu beschweren:
        </p>
        <ul>
          <li>
            <strong>Schweiz:</strong> Eidgenössischer Datenschutz- und
            Öffentlichkeitsbeauftragter (EDÖB) –{' '}
            <a href="https://www.edoeb.admin.ch" target="_blank" rel="noopener noreferrer">
              www.edoeb.admin.ch
            </a>
          </li>
          <li>
            <strong>EU (falls anwendbar):</strong> Die zuständige Datenschutzbehörde in Ihrem
            Wohnsitzland.
          </li>
        </ul>

        <h2>10. Datensicherheit</h2>
        <p>
          Wir setzen technische und organisatorische Massnahmen ein, um Ihre Daten vor unbefugtem
          Zugriff, Verlust oder Missbrauch zu schützen:
        </p>
        <ul>
          <li>Passwörter werden ausschliesslich als bcrypt-Hash gespeichert</li>
          <li>Authentifizierung über sichere Tokens mit begrenzter Gültigkeit</li>
          <li>Zugriffskontrollen: Nutzer können nur eigene Daten bearbeiten</li>
          <li>Datei-Uploads sind auf Bildformate und 5 MB limitiert</li>
        </ul>

        <h2>11. Minderjährige</h2>
        <p>
          Unsere Plattform richtet sich nicht gezielt an Kinder unter 16 Jahren. Wir erheben
          wissentlich keine Daten von Minderjährigen. Falls uns bekannt wird, dass Daten von
          Personen unter 16 Jahren ohne Einwilligung erhoben wurden, löschen wir diese umgehend.
        </p>

        <h2>12. Änderungen dieser Datenschutzerklärung</h2>
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen. Die jeweils
          aktuelle Version ist stets auf dieser Seite abrufbar.
        </p>

        <h2>13. Kontakt</h2>
        <p>Bei Fragen, Anliegen oder zur Ausübung Ihrer Rechte:</p>
        <div className="contact-box">
          <p style={{ marginBottom: 4 }}><strong>WennWieWo</strong></p>
          <p style={{ marginBottom: 0 }}>E-Mail: kontakt@wennwiewo.ch</p>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
